import gql from "graphql-tag";
import { Coupon } from "../../types/generalTypes";

export interface CouponVariables {
  coupon: string;
}

export interface ApplyCouponResponse {
  applyCoupon: {
    cart: {
      total: string;
      appliedCoupons: Coupon[] | null;
    };
  };
}

export interface RemoveCouponResponse {
  removeCoupons: {
    cart: {
      total: string;
      appliedCoupons: Coupon[] | null;
    };
  };
}

export const applyCoupon = gql`
  mutation applyCoupon($coupon: String!) {
    applyCoupon(input: { clientMutationId: "ADD_COUPON", code: $coupon }) {
      cart {
        total
        appliedCoupons {
          code
          discountAmount
          description
        }
      }
    }
  }
`;

export const removeCoupons = gql`
  mutation removeCoupons($coupon: [String]) {
    removeCoupons(
      input: { clientMutationId: "REMOVE_COUPONS", codes: $coupon }
    ) {
      cart {
        total
        appliedCoupons {
          code
          discountAmount
          description
        }
      }
    }
  }
`;
